/**
 * Runtime toast yardimcilari
 */

function removeToast(toast: HTMLElement): void {
    if (!toast || !toast.parentNode) return;
    toast.style.animation = 'toastSlideOut 0.3s ease forwards';
    setTimeout(() => {
        if (toast.parentNode) toast.remove();
    }, 300);
}

export function showToast(message: string, type = 'info', options: any = {}): HTMLElement | undefined {
    const container = document.getElementById('toast-container');
    if (!container) return undefined;

    const {
        duration = type === 'error' ? 5000 : 3000,
        dismissible = true,
        action = null
    } = options;

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', type === 'error' ? 'assertive' : 'polite');

    const icons: Record<string, string> = {
        success: '✅',
        error: '❌',
        warning: '⚠️',
        info: 'ℹ️',
        loading: '⏳'
    };

    let html = `
        <span class="toast-icon">${icons[type] || icons.info}</span>
        <span class="toast-message">${message}</span>
    `;

    if (action?.label) {
        html += `<button class="toast-action" type="button">${action.label}</button>`;
    }

    if (dismissible) {
        html += '<button class="toast-close" type="button" aria-label="Kapat">×</button>';
    }

    toast.innerHTML = html;

    if (action?.callback) {
        toast.querySelector('.toast-action')?.addEventListener('click', () => {
            action.callback();
            removeToast(toast);
        });
    }

    if (dismissible) {
        toast.querySelector('.toast-close')?.addEventListener('click', () => removeToast(toast));
    }

    container.appendChild(toast);

    if (duration > 0) {
        setTimeout(() => removeToast(toast), duration);
    }

    return toast;
}

export function showSuccessToast(message: string, options?: any): HTMLElement | undefined {
    return showToast(message, 'success', options);
}

export function showErrorToast(message: string, options?: any): HTMLElement | undefined {
    return showToast(message, 'error', { duration: 5000, ...options });
}

export function showLoadingToast(message: string): HTMLElement | undefined {
    return showToast(message, 'loading', { duration: 0, dismissible: false });
}
